//	Helio v1.1, Copyright 2014, Joe Mottershaw, https://github.com/joemottershaw/
//	=============================================================================

//	Table of Contents
//	==================================================
//		#Tipsy
//		#FitVids
//		#Void Links
//		#Navigation Dropdown
//		#Litebox
//		#Quantity Steps
//		#Password Input
//		#Scrolling


//	#Tipsy
//	==================================================

	$(document).ready(function() {
		// Show/Hide
			$('.tip-tl').tipsy({ gravity: 'se', html: true, title: 'data-tooltip', offset: 5, live: true });
			$('.tip-t').tipsy({ gravity: 's', html: true, title: 'data-tooltip', offset: 5, live: true });
			$('.tip-tr').tipsy({ gravity: 'sw', html: true, title: 'data-tooltip', offset: 5, live: true });
			$('.tip-r').tipsy({ gravity: 'w', html: true, title: 'data-tooltip', offset: 5, live: true });
			$('.tip-br').tipsy({ gravity: 'nw', html: true, title: 'data-tooltip', offset: 5, live: true });
			$('.tip-b').tipsy({ gravity: 'n', html: true, title: 'data-tooltip', offset: 5, live: true });
			$('.tip-bl').tipsy({ gravity: 'ne', html: true, title: 'data-tooltip', offset: 5, live: true });
			$('.tip-l').tipsy({ gravity: 'e', html: true, title: 'data-tooltip', offset: 5, live: true });

		// Fade In/Out
			$('.tip-tl-fade').tipsy({ gravity: 'se', html: true, title: 'data-tooltip', offset: 5, fade: true, fadeSpeed: 150, live: true });
			$('.tip-t-fade').tipsy({ gravity: 's', html: true, title: 'data-tooltip', offset: 5, fade: true, fadeSpeed: 150, live: true });
			$('.tip-tr-fade').tipsy({ gravity: 'sw', html: true, title: 'data-tooltip', offset: 5, fade: true, fadeSpeed: 150, live: true });
			$('.tip-r-fade').tipsy({ gravity: 'w', html: true, title: 'data-tooltip', offset: 5, fade: true, fadeSpeed: 150, live: true });
			$('.tip-br-fade').tipsy({ gravity: 'nw', html: true, title: 'data-tooltip', offset: 5, fade: true, fadeSpeed: 150, live: true });
			$('.tip-b-fade').tipsy({ gravity: 'n', html: true, title: 'data-tooltip', offset: 5, fade: true, fadeSpeed: 150, live: true });
			$('.tip-bl-fade').tipsy({ gravity: 'ne', html: true, title: 'data-tooltip', offset: 5, fade: true, fadeSpeed: 150, live: true });
			$('.tip-l-fade').tipsy({ gravity: 'e', html: true, title: 'data-tooltip', offset: 5, fade: true, fadeSpeed: 150, live: true });
	});


//	#FitVids
//	==================================================

	$(document).ready(function() {
		$('body').fitVids();
	});


//	#Void Links
//	==================================================

	$(document).ready(function() {
		$('.void-link').on('click', function(e) {
			e.preventDefault();
		});
	});


//	#Navigation Dropdown
//	==================================================

	$(document).ready(function() {
		$('#click-nav .nav-item').hover(function() {
			$('.sub-nav', this).stop(true, true).fadeIn(200);
		}, function() {
			$('.sub-nav', this).stop(true, true).fadeOut(200);
		});

		$('#touch-nav .toggle-icon').on('click', function(e) {
			e.preventDefault();
			
			$(this).next('.slide-menu').stop().slideToggle();
		});

		$('#touch-nav .nav-item .parent-link').on('click', function(e) {
			e.preventDefault();

			$(this).next('.sub-nav').stop().slideToggle(200);
		});
	});


//	#Litebox
//	==================================================

	$(document).ready(function() {
		$('.litebox').liteBox();
	});


//	#Quantity Steps
//	==================================================

	// Set as function for Shopify Quick Look init

	function initQtySteps() {
		$('.input-quantity-minus').on('click', function(e) {
			e.preventDefault();
			
			var	input = $(this).next('input'),
				inputQty = parseInt($(input).val()),
				min = parseInt($(input).attr('data-qty-min')),
				step = parseInt($(input).attr('data-qty-step'));

			if (!min || min == '') min = 1;
			if (!step || step == '') step = 1;

			var	qty = (inputQty - step);

			if (inputQty % 1 != 0) qty = 1;

			if (qty >= min) $(input).val(qty);
		});

		$('.input-quantity-plus').on('click', function(e) {
			e.preventDefault();
			
			var input = $(this).prev('input'),
				inputQty = parseInt($(input).val()),
				max = parseInt($(input).attr('data-qty-max')),
				step = parseInt($(input).attr('data-qty-step'));

			if (!max || max == '') max = 9999;
			if (!step || step == '') step = 1;

			var	qty = (inputQty + step);

			if (inputQty % 1 != 0) qty = 1;

			if (qty <= max) {
				$(input).val(qty);
			} else {
				$('body').edgeAlerts({
					title: 'Update Error',
					message: 'There are only ' + max + ' of these available.'
				});
			}
		});
	}

	$(document).ready(function() {
		initQtySteps();
	});


//	#Password Input
//	==================================================

	$(document).ready(function() {
		$('.fake-password').focus(function() {
			$(this).hide().next('input').removeClass('no-display').focus();
		});

		$('.true-password').blur(function() {
			var truePassword = $(this).val();

			if (!truePassword.length) $(this).addClass('no-display').focus().prev('input').show();
		});
	});


//	#Scrolling
//	==================================================

	$(function() {
		$('a[href*=#]:not([href=#])').on('click', function() {
			if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
				var target = $(this.hash);

				target = target.length ? target : $('[name=' + this.hash.slice(1) +']');

				if (target.length) 
					$('html, body').animate({ scrollTop: target.offset().top - 40 }, 1400, 'easeInOutQuart');
					return false;
			}
		});
	});

	$(document).ready(function() {
		$('.scroll-to-top').on('click', function() {
			$('html, body').animate({ scrollTop: 0 }, 1600, 'easeInOutQuart');
			return false;
		});
	});